import { xAdd, xMinValue } from 'ml-spectra-processing';
/**
 * Filter that allows to
 * @param data
 * @param options
 */
export function setMinY(data, options = {}) {
    const { min = 0 } = options;
    const existingMin = xMinValue(data.y);
    if (existingMin === min) {
        return { data };
    }
    return {
        data: {
            x: data.x,
            y: xAdd(data.y, min - existingMin),
        },
    };
}
//# sourceMappingURL=setMinY.js.map